/** See GroupGrantType.kt */
const GROUP_GRANT_TYPE = {
	EXPLICIT: 'explicit',
	IMPLICIT: 'implicit',
	VIEW_ALL: 'view-all',
	ROLLUP_TREE_GROUP: 'rollup-tree-group',
}

export default GROUP_GRANT_TYPE

GROUP_GRANT_TYPE.__filename__ = 'admin/org-permissions-audit/group-grant-type.js'
